import {
  Box,
  Container,
  Grid2,
  Typography,
  Button
} from '@mui/material'

export const ServerError = () => {
  const handleClick = () => {
    window.location.href = 'https://www.terashite.jp/'
  }
  return (
    <Box>
      <Container maxWidth="xl">
        <Grid2 container>
          <Grid2 size={{ sm: 2 }} />
          <Grid2 size={{ lg: 8, sm: 8 }} spacing={10}>
            <Typography variant="h4" align='center'>
              サーバーエラーが発生しました。
            </Typography>
            <Typography variant="body1" mt={10} align='center'>
              サーバで一時的なエラーが発生しました。<br />
              大変お手数ですが、しばらく時間を置いてからもう一度やり直してください。
            </Typography>
            <Box display={'flex'} justifyContent={'space-around'} mt={10}>
              <Button variant="contained" color="primary" onClick={handleClick}>
                テラシテトップに戻る
              </Button>
            </Box>
          </Grid2>
        </Grid2>
      </Container>
    </Box>
  )
}
